import React, { useState, useEffect } from 'react';
import { Button, App, Steps, Tooltip } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { getOrderCount } from '@/api/order';
//使用国际化
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@/store/hooks';
import { CheckCircleFilled } from '@ant-design/icons';
import icon1 from '@/assets/images/路径 1717.png';
import styles from './index.module.scss';
import StoreEntryStep1 from './components/StoreEntryStep1/StoreEntryStep1';
import StoreEntryStep2 from './components/StoreEntryStep2/StoreEntryStep2';
import StoreEntryStep3 from './components/StoreEntryStep3/StoreEntryStep3';
import StoreEntryStep4 from './components/StoreEntryStep4/StoreEntryStep4';
import StoreEntryStep5 from './components/StoreEntryStep5/StoreEntryStep5';
import StoreEntryStep6 from './components/StoreEntryStep6/StoreEntryStep6';
import { IFormDataAll } from './types';
import dayjs from 'dayjs';


const StoreEntry: React.FC = () => {
  //国际化语言切换 AI不要删除
  const { t } = useTranslation();

  const { message } = App.useApp();
  //跳转
  const navigate = useNavigate();

  const params = useParams();

  //表单的总数据
  const [formDataAll, setFormDataAll] = useState<IFormDataAll>(
    {
      "merchant_name": "",
      "company_name": "",
      "email": "",
      "phone": "",
      "business_phone": "",
      "phone_code": "",
      "first_name": "",
      "last_name": "",
      "state": "",
      "city": "",
      "address": "",
      "building": "",
      "zip_code": "",

      "merchant_type": 1,
      "merchant_logo_file_url": "",
      "can_publish": true,
      "can_login": true,
      "can_trade": true,
      "longitude": 0,
      "latitude": 0,

      "store_url_slug": "",
      "primary_category": "",
      "store_description":
        "",
      "return_policy_summary":
        "",

      "legal_first_name": "",
      "date_of_birth": '',
      "ssn_itin_last4": "",
      "government_id_type": "",
      "id_number": '',
      "government_id_token": "",

      "tax_form_selection": "",

      "doing_business_as": "",
      "entity_type": "",
      "state_of_registration": "",
      "registration_number": "",
      "ein": "",
      "website": "",
      government_id_upload: [],

      "beneficial_owners": [],

      "tax_settings": "",

      "certificate_of_insurance": [],
      "payout_account": "",
      "payout_schedule": "",

      "reserve_settings": [],

      "kyc_kyb_status": "approved",

      "form_1099k_consent": true,
      "form_1099k_delivery_method": "postal_mail",

      "store_logo": [],
      payout_account_type: '',
      payment_method: '',
      account_number: '',
      routing_number: '',
      account_name: '',
      bank_name: '',
      reserve_amount: '',
      reserve_period: '',

    }
  );


  // 当前步骤 - 从localStorage恢复状态
  const [currentStep, setCurrentStep] = useState(() => {
    const savedStep = localStorage.getItem('storeEntryCurrentStep');
    return savedStep ? parseInt(savedStep, 10) : 0;
  });
  const [storeType, setStoreType] = useState<'individual' | 'business'>('individual');

  // 获取用户地理位置
  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          console.log('获取到的位置信息:', { latitude, longitude });

          // 更新formDataAll中的经纬度
          setFormDataAll(prev => ({
            ...prev,
            longitude: longitude,
            latitude: latitude
          }));
        },
        (error) => {
          console.error('获取位置失败:', error);
          // 可以根据需要显示错误提示
          switch (error.code) {
            case error.PERMISSION_DENIED:
              message.warning('用户拒绝了位置请求');
              break;
            case error.POSITION_UNAVAILABLE:
              message.warning('位置信息不可用');
              break;
            case error.TIMEOUT:
              message.warning('获取位置超时');
              break;
            default:
              message.warning('获取位置时发生未知错误');
              break;
          }
        },
        {
          enableHighAccuracy: true, // 启用高精度
          timeout: 10000, // 10秒超时
          maximumAge: 60000 // 缓存1分钟
        }
      );
    } else {
      console.error('浏览器不支持地理位置服务');
      message.warning('您的浏览器不支持地理位置服务');
    }
  };

  // 页面初始化时获取地理位置
  useEffect(() => {
    getCurrentLocation();

    getOrderCount();
  }, []);

  // 步骤数据
  const steps = [
    {
      title: t('storeEntry.StoreBasics'),
      description: '',
      status: 'process',
    },

    // {
    //   title: t('storeEntry.AccountVerification'),
    //   description: '',
    //   status: 'wait',
    // },
    {
      title: t('storeEntry.IdentityCompliance'),
      description: '',
      status: 'wait',
    },
    {
      title: t('storeEntry.PayoutsRiskControl'),
      description: '',
      status: 'wait',
    },
    {
      title: t('storeEntry.FirstListingSetup'),
      description: '',
      status: 'wait',
    },
    {
      title: t('storeEntry.FinishEnterSellerDashboard'),
      description: '',
      status: 'wait',
    },
  ];

  // 处理下一步
  const handleNext = (submitData: any) => {
    console.log(submitData, 'submitData');

    const formDataAllCopy = { ...formDataAll, ...submitData };

    console.log(formDataAllCopy, 'formDataAllCopy');

    setFormDataAll(formDataAllCopy);

    if (currentStep < steps.length - 1) {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);
      // 保存步骤状态到localStorage
      localStorage.setItem('storeEntryCurrentStep', nextStep.toString());
    }
    window.scrollTo(0, 0);
  };

  // 处理上一步
  const handlePrev = () => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1;
      setCurrentStep(prevStep);
      // 保存步骤状态到localStorage
      localStorage.setItem('storeEntryCurrentStep', prevStep.toString());
    }
    window.scrollTo(0, 0);
  };

  // 处理取消
  const handleCancel = () => {
    // 这里可以添加取消逻辑，例如返回首页
    console.log('Cancelled');
  };

  // 处理店铺类型
  const handleStoreType = (type: 'individual' | 'business') => {
    setStoreType(type);
    console.log(storeType);
  };

  // 渲染左侧导航
  const renderNavItems = () => {
    return steps.map((step, index) => {
      const isCompleted = index < currentStep;
      const isActive = index === currentStep;
      const isFirst = index === 0;

      return (
        // onClick={() => setCurrentStep(index)}

        <div
          key={index}
          className={`${styles['nav-item']} ${isActive ? styles['active'] : ''} ${isCompleted ? styles['completed'] : ''} ${isFirst && isActive ? styles['first-active'] : ''}`}
        >
          <div className={styles['nav-icon']}>
            {isCompleted ? <CheckCircleFilled /> : <span>{index + 1}</span>}
          </div>
          <div className={styles['nav-text']}>{step.title}</div>
        </div>
      );
    });
  };

  // 渲染提示
  const renderSecurityTip = () => {
    return (
      <div className={styles['security-tip-box']}>
        <div className={styles['security-tip']}>
          <img src={icon1} alt="icon1" className={styles['security-icon']} />
          <span>Your Information Is Being Protected. Please Feel Free To Fill It Out.</span>
        </div>
      </div>
    );
  };

  // 渲染当前步骤内容
  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <div className={styles['step-content']}>
            {/* 表单内容将在这里实现 */}
            <StoreEntryStep1
              onNext={handleNext}
              onCancel={handleCancel}
              getStoreType={handleStoreType}
              formData={formDataAll}
            />
          </div>
        );

      // case 1:
      //   return (
      //     <div className={styles['step-content']}>
      //       {/* 账户认证内容 */}
      //       <StoreEntryStep2
      //         onNext={handleNext}
      //         onPrev={handlePrev}
      //         storeType={storeType}
      //       />
      //     </div>
      //   );

      case 1:
        return (
          <div className={styles['step-content']}>
            {/* 身份确认内容 */}
            <StoreEntryStep3
              onNext={handleNext}
              onPrev={handlePrev}
              storeType={storeType}
              formData={formDataAll}
            />
          </div>
        );

      case 2:
        return (
          <div className={styles['step-content']}>
            {/* 支付和风控内容 */}
            <StoreEntryStep5
              onNext={handleNext}
              onPrev={handlePrev}
              storeType={storeType}
              formData={formDataAll}
            />
          </div>
        );
      case 3:
        return (
          <div className={styles['step-content']}>
            {/* 首次商品设置内容 */}
            <StoreEntryStep6
              onNext={handleNext}
              onPrev={handlePrev}
              storeType={storeType}
              formData={formDataAll}
            />
          </div>
        );
      case 4:
        return (
          <div className={styles['step-content']}>
            {/* 完成页面 */}
            <StoreEntryStep4
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles['store-entry']}>
      {/* {JSON.stringify(formDataAll)} */}
      <h1 className={styles['page-title']}>{t('storeEntry.StoreEntryProcess')}</h1>

      <div className={styles['entry-container']}>
        {/* 左侧导航 */}
        <div className={styles['side-nav']}>
          {renderNavItems()}
        </div>

        {/* 右侧内容区 */}
        <div className={styles['main-content']}>

          {/* 步骤内容 */}
          <div className={styles['content-container']}>
            {renderStepContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreEntry; 